import React, { useState, useEffect } from "react";
import axios from "axios";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

function ResetPassword() {
  const [userType, setUserType] = useState("");
  const [districts, setDistricts] = useState([]);
  const [users, setUsers] = useState([]);
  const [district, setDistrict] = useState("");
  const [userId, setUserId] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [loading, setLoading] = useState(false);
  const [captchaImg, setCaptchaImg] = useState(
  `${process.env.REACT_APP_URL}/api/reset/captcha`
);

  useEffect(() => {
    if (userType === "2" || userType === "3") {
      axios
        .get(`${process.env.REACT_APP_URL}/api/reset/getDist`)
        .then((res) => setDistricts(res.data));
    }
  }, [userType]);

  // fetch users dynamically when district or type changes
  useEffect(() => {
    if (district && (userType === "2" || userType === "3")) {
      axios
        .get(`${process.env.REACT_APP_URL}/api/reset/users?type=${userType}&district=${district}`)
        .then((res) => setUsers(res.data));
    } else if (userType && ["9", "10", "22"].includes(userType)) {
      axios
        .get(`${process.env.REACT_APP_URL}/api/reset/users?type=${userType}`)
        .then((res) => setUsers(res.data));
    }
  }, [district, userType]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userType){ 
      alert("Please Select User Type") 
      return false
     }
    if (!userId) {
       alert("Please Select User");
      return false;
    }
    if (!captcha) {
      alert("Please Enter Captcha");
      return false;
    } 

    try {
      setLoading(true);
      const response = await axios.post(`${process.env.REACT_APP_URL}/api/reset/resetPassword`, {
        userId,    
        captcha,    
      });

      alert(response.data);
    } catch (err) {
      console.error(err);
      alert("Error resetting password");
    }
    setLoading(false);
  };

  return (
    <div>
      <br />
      <form onSubmit={handleSubmit}>
        <table align="center" width="40%" border="1">
          <thead>
            <tr className="tableheader">
              <th colSpan={2}>Reset Password</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>User Type</td>
              <td>
                <select
                  required
                  value={userType}
                  onChange={(e) => {
                    setUserType(e.target.value);
                    setDistrict("");
                    setUserId("");
                    setUsers([]);
                  }}
                >
                  <option value="">-Select-</option>
                  <option value="2">DFSO</option>
                  <option value="3">JSO</option>
                  <option value="9">GM</option>
                  <option value="10">Accounts</option>
                  <option value="22">CS</option>
                </select>
              </td>
            </tr>

            {(userType === "2" || userType === "3") && (
              <tr>
                <td>District</td>
                <td>
                  <select
                    required
                    value={district}
                    onChange={(e) => setDistrict(e.target.value)}
                  >
                    <option value="">-Select District-</option>
                    {districts.map((d) => (
                      <option key={d.dist_code} value={d.dist_code}>
                        {d.dist_name_en}
                      </option>
                    ))}
                  </select>
                </td>
              </tr>
            )}

            <tr>
              <td>User</td>
              <td>
                <select
                  required
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                >
                  <option value="">-Select User-</option>
                  {users.map((u) => (
                    <option key={u.user_id} value={u.user_id}>
                      {u.user_name} ({u.user_id})
                    </option>
                  ))}
                </select>
              </td>
            </tr>

            <tr align="center">
              <td colSpan={2}>
                <img
                  src={captchaImg}
                  alt="captcha"
                  width="150"
                  height="50"
                  // onClick={() => setCaptchaImg(`${process.env.REACT_APP_URL}/auth/refresh-captcha}`)}
                  // style={{ cursor: "pointer" }}
                />
              </td>
            </tr>

            <tr>
              <td>Captcha</td>
              <td>
                <input
                  type="text"
                  value={captcha}
                  onChange={(e) => setCaptcha(e.target.value)}
                  required
                  placeholder="Enter Captcha"
                />
              </td>
            </tr>

            <tr align="center">
              <td colSpan={2}>
                <input
                  type="submit"
                  className="button button2"
                  value="Reset"
                  onClick={handleSubmit}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </form>
      <br></br>
      {loading &&
                  <div style={{display:'flex', justifyContent:'center',alignItems:'center'}}><Box sx={{ display: 'flex'}}>
                  <CircularProgress />
              </Box></div>
          } 
    </div>
  );
}

export default ResetPassword;
